import { Transform } from "class-transformer";
import { VehicleMaintenanceStatusEnum } from "@altertec_gparn/lib";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { toKilometers } from "@/utils/numberUtils";

export class PlanningBoardVehicleMaintenanceDto {
  vehicleId: string;

  title: string;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  dueDate?: Date | null;

  @Transform(({ value }) => (value == null ? null : toKilometers(value)))
  mileageLimit?: number | null;

  status: VehicleMaintenanceStatusEnum;

  isExpired: boolean;
}
